const { origin } = window.location;

const judgeEnvConfig: any = {
  dev: {
    keyWords: ['localhost', '127.0.0.1'],
  },
  sit: {
    keyWords: ['sit', 'test'],
  },
  demo: {
    keyWords: ['demo'],
  },
};

const retrieveKeyWord = (keyWords: string[]) => {
  return keyWords.filter((key) => origin.indexOf(key) > -1).length > 0;
};

const judgeEnv = () => {
  let env;
  const keys = Object.keys(judgeEnvConfig);
  keys.forEach((key) => {
    if (retrieveKeyWord(judgeEnvConfig[key].keyWords)) {
      env = key;
    }
  });
  return env;
};
// 运行中的环境参数，通过域名检索关键字判断（非严谨的，故默认生产环境）
const nodeRuntimeEnv = judgeEnv() || 'pro';
console.log('NODE_RUNTIME_ENV', nodeRuntimeEnv);
export const NODE_RUNTIME_ENV = nodeRuntimeEnv;
export default {
  NODE_RUNTIME_ENV,
};
